<template>
    <div>
        <head-top></head-top>
        <nav-side></nav-side>
        <div id="content" class="content">
            <transition name="fade-transform" mode="out-in">
                <router-view />
            </transition>
        </div>
    </div>
</template>

<script>
import headTop from "./components/containWraper/head";
import navSide from "./components/containWraper/nav";

export default {
    data() {
        return {};
    },
    components: { headTop, navSide },
    methods: {},
    created() {
        if (location.host.includes("usa")) {
            this.$store.commit("SET_ENVIR_VERSION", "usa");
        } else {
            this.$store.commit("SET_ENVIR_VERSION", "tw");
        }
    },
    mounted() {}
};
</script>

<style lang="less">
@import url(./styles/public);
.content {
    height: 100%;
    margin: 50px 20px 0 220px;
    padding: 20px 0 20px;
    box-sizing: border-box;
    &.collapse {
        margin-left: 85px;
    }
}
</style>



// WEBPACK FOOTER //
// src/App.vue